import type { Insight, InsightLevel } from './WeatherStation';

// El resumen de una palabra del Inicio ("Óptima", "Atención", "Riesgo"):
// lo peor entre las lecturas inteligentes (aplicación, helada, humedad) y el
// estado del suelo. El detalle es el motivo, para que el título no quede solo.
export interface FieldCondition {
  level: InsightLevel;
  title: string;
  detail: string;
}

const RANK: Record<InsightLevel, number> = { ok: 0, caution: 1, bad: 2 };
const TITLE: Record<InsightLevel, string> = {
  ok: 'Óptima',
  caution: 'Atención',
  bad: 'Riesgo',
};

export function fieldCondition(insights: Insight[], soil: { level: InsightLevel; label: string } | null): FieldCondition | null {
  const items: Insight[] = [...insights];
  if (soil) {
    items.push({
      level: soil.level,
      title: `Suelo: ${soil.label.toLowerCase()}`,
      detail:
        soil.level === 'ok'
          ? 'La humedad del suelo está dentro del rango ideal.'
          : `La humedad del suelo está ${soil.label.toLowerCase()}.`,
    });
  }
  if (items.length === 0) return null;
  const worst = items.reduce((a, b) => (RANK[b.level] > RANK[a.level] ? b : a));
  if (worst.level === 'ok') {
    return {
      level: 'ok',
      title: TITLE.ok,
      detail: soil?.level === 'ok' ? 'La humedad del suelo está dentro del rango ideal.' : 'Todo dentro de los criterios de la estación.',
    };
  }
  return {
    level: worst.level,
    title: TITLE[worst.level],
    detail: `${worst.title}. ${worst.detail}`,
  };
}
